import { getInitialState, getPath } from "../../utils";

const initialState = {
  prizeItemList: [],
  prevPage: -1,
  nextPage: -1,
  activePrizeItem: { serviceId: [] },
  activeFilters: { serviceId: [] },
  currentPage: 1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_PRIZE_ITEM_LIST":
      return setPrizeItemList(state, action);
    case "SET_ACTIVE_PRIZE_ITEM":
      return setActivePrizeItem(state, action);
    case "SET_ACTIVE_FILTERS_PRIZE_ITEM":
      return setActiveFilters(state, action);
    case "SET_CURRENT_PAGE_PRIZE_ITEM":
      return setCurrentPageFeature(state, action);
    case "RESET_STATE_PRIZE_ITEM":
      return resetState(state, action);
    default:
      return state;
  }
}

const setCurrentPageFeature = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setPrizeItemList = (state, action) => {
  return {
    ...state,
    prizeItemList: getPath(action.payload, "prizeItems", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActivePrizeItem = (state, action) => {
  return {
    ...state,
    activePrizeItem: action.payload,
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
